export const shouldLoad = () => document.querySelector('[data-controller="contact-section"]') !== undefined;